import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FORMAT_MINUTES_SECONDS,
  now,
  format,
  msToDate,
  differenceInMilliseconds,
} from 'helpers/DateTimeHelper';
import style from './VideoContainer.module.scss';

const INTERVAL_MS = 1000;
class Timer extends Component {
  constructor(props) {
    super(props);
    const { unixEndTime } = this.props;
    const time = differenceInMilliseconds(msToDate(unixEndTime), now());

    this.state = { time };
    this.interval = null;
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.checkTime();
    }, INTERVAL_MS);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { unixEndTime: nextUnixEndTime } = nextProps;
    const { time: nextTime } = nextState;
    const { time } = this.state;
    const { unixEndTime } = this.props;
    return unixEndTime !== nextUnixEndTime || nextTime !== time;
  }

  componentWillUnmount() {
    if (this.interval) {
      this.checkTime();
    }
    this.clearInterval();
  }

  checkTime = () => {
    const { unixEndTime, expirationCallback } = this.props;
    const time = differenceInMilliseconds(msToDate(unixEndTime), now());
    if (time <= 0) {
      this.clearInterval();
      expirationCallback();
    }
    this.setState({ time });
  };

  clearInterval = () => {
    clearInterval(this.interval);
    this.interval = null;
  };

  render() {
    const { time } = this.state;
    if (time <= 0) {
      return null;
    }
    const readableTime = format(msToDate(time), FORMAT_MINUTES_SECONDS);
    return <span className={style.previewPassCountdown}>{readableTime}</span>;
  }
}

Timer.propTypes = {
  unixEndTime: PropTypes.number.isRequired,
  expirationCallback: PropTypes.func.isRequired,
};

export default Timer;
